export default class PasswordValidationUserData {
    constructor (json = null) {
        this.email = null;
        this.firstName = null;
        this.lastName = null;

        if (json) {
            mapJsonToPasswordValidationUserData(json, this);
        }
    }

    createCopy () {
        const validationUserData = new PasswordValidationUserData();
        validationUserData.email = this.email;
        validationUserData.firstName = this.firstName;
        validationUserData.lastName = this.lastName;
        return validationUserData;
    }
}

const mapJsonToPasswordValidationUserData = (json, passwordValidationUserData) => {
    passwordValidationUserData.email = json.Email;
    passwordValidationUserData.firstName = json.FirstName;
    passwordValidationUserData.lastName = json.LastName;
};

const mapUserToPasswordValidationUserData = (user, passwordValidationUserData) => {
    if (user.Contact) {
        passwordValidationUserData.email = user.Contact.Email;
        passwordValidationUserData.firstName = user.Contact.FirstName;
        passwordValidationUserData.lastName = user.Contact.LastName;
    }
};

export const createPasswordValidationUserDataFromUser = (user) => {
    const validationUserData = new PasswordValidationUserData();
    if (user) {
        mapUserToPasswordValidationUserData(user, validationUserData);
    }
    return validationUserData;
};
